import React from 'react'

const PostCallActionsContext = React.createContext({
  pathwayId: null,
  postCallActions: [],
  onPostCallActionsChange: () => {},
  setIsSaving: () => {},
})

export default PostCallActionsContext
